import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FetchData from '../../../Framework/Fetch';
import isPresent from '../../../Common/Utils/Present';

const styles = createStyles({
  fields: {
    overflow: 'inherit'
  }
});

type Props = {
  classes: any,
  record: any,
};

type StateProps = {
  adTagBody: string[],
  adTagHead: string[],
  displayAdTagBody: boolean,
  displayAdTagHead: boolean
};

class AdTagsTab extends Component<Props, StateProps> {
  state = {
    adTagBody: [],
    adTagHead: [],
    displayAdTagBody: false,
    displayAdTagHead: false
  };

  handleClick = () => {
    FetchData(`/helpers/placement_tags/${this.props.record.id}`, {})
      .then((json) => {
        this.setState({
          adTagBody: json.body,
          adTagHead: json.head,
          displayAdTagBody: isPresent(json.body),
          displayAdTagHead: isPresent(json.head)
        });
      });
  };

  render() {
    return (
      <div style={{ paddingLeft: 15, paddingTop: 20 }}>
        <Button
          color="primary"
          className={this.props.classes.fields}
          onClick={this.handleClick}
          variant="raised"
        >Generate Ad Tag</Button><br /><br />
        <div style={{ display: (this.state.displayAdTagHead ? 'initial' : 'none') }}>
          <hr style={{ color: 'rgba(0, 0, 0, 0.298039)' }} /><br />
          <i><b>Paste in HTML &lt;head&gt;</b></i><br />
          {this.state.displayAdTagHead && this.state.adTagHead.map((line, index) => {
            return (<div key={index}>{line}</div>);
          })}<br /><br />
        </div><br />

        <div style={{ display: (this.state.displayAdTagBody ? 'initial' : 'none') }}>
          <i><b>Paste in HTML &lt;body&gt;</b></i><br />
          {this.state.displayAdTagBody && this.state.adTagBody.map((line, index) => (
            <div key={index}>{line}</div>
          ))}<br /><hr style={{ color: 'rgba(0, 0, 0, 0.298039)' }} />
        </div>
      </div>
    )
  }
};

export default withStyles(styles)(AdTagsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdTagsTab.tsx